export default "__VITE_ASSET__85773d83__$_?component__"